function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LeaderboardIndicators = exports.LeaderboardIndicatorPosition = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native-web");
var _styles = require("./styles");
var _Button = require("../../../Button");
var _View = require("../../../View");
var _styles2 = require("../../../../styles");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var LeaderboardIndicatorPosition = exports.LeaderboardIndicatorPosition = function (LeaderboardIndicatorPosition) {
  LeaderboardIndicatorPosition["top"] = "top";
  LeaderboardIndicatorPosition["bottom"] = "bottom";
  return LeaderboardIndicatorPosition;
}({});
var LeaderboardIndicators = exports.LeaderboardIndicators = (0, _react.memo)(function (_ref) {
  var items = _ref.items,
    position = _ref.position,
    _onPress = _ref.onPress;
  var _useStyles = (0, _styles.useStyles)(),
    styles = _useStyles.styles;
  var _STYLES$useStyles = _styles2.STYLES.useStyles(),
    spacing = _STYLES$useStyles.spacing;
  var _useState = (0, _react.useState)(items == null ? void 0 : items.reduce(function (a, v) {
      return Object.assign({}, a, (0, _defineProperty2["default"])({}, v.id, false));
    }, {})),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    _isPointerOver = _useState2[0],
    _setIsPointerOver = _useState2[1];
  if (!items || items.length === 0) {
    return null;
  }
  return (0, _jsxRuntime.jsx)(_View.View, {
    style: [styles.container, styles["container_".concat(position)]],
    testID: "LeaderboardIndicators",
    spacer: spacing.xs,
    children: items.map(function (item) {
      return (0, _jsxRuntime.jsx)(_Button.Button, {
        label: item.label,
        onPress: function onPress() {
          return _onPress == null ? void 0 : _onPress(item.page);
        },
        type: _Button.ButtonType.blank,
        onPointerEnter: function onPointerEnter() {
          return _setIsPointerOver(function (prev) {
            return Object.assign({}, prev, (0, _defineProperty2["default"])({}, item.id, true));
          });
        },
        onPointerLeave: function onPointerLeave() {
          return _setIsPointerOver(function (prev) {
            return Object.assign({}, prev, (0, _defineProperty2["default"])({}, item.id, false));
          });
        },
        testID: "LeaderboardIndicatorsItem",
        children: (0, _jsxRuntime.jsx)(_View.View, {
          style: [styles.imageContainer, (_isPointerOver == null ? void 0 : _isPointerOver[item.id]) && styles.imageContainer_pointerOver],
          children: item.image ? (0, _jsxRuntime.jsx)(_reactNative.ImageBackground, {
            source: {
              uri: item.image
            },
            style: styles.image,
            resizeMode: "cover"
          }) : (0, _jsxRuntime.jsx)(_reactNative.Text, {
            style: styles.text,
            children: item.label.substring(0, 1)
          })
        })
      }, item.id);
    })
  });
});